import request from '@/utils/request'

export function getDashboardStats() {
  return request({ url: '/admin/dashboard/stats', method: 'post' })
}

/** 综合统计概览：各业务总量 + 优惠券统计 */
export function getStatisticsOverview() {
  return request({ url: '/admin/statistics/overview', method: 'post' })
}

/** 今日实时统计：今日新增用户/产品订单/支付金额/服务订单 */
export function getStatisticsToday(data = {}) {
  return request({ url: '/admin/statistics/today', method: 'post', data })
}

/** 图表数据：近30天趋势 + 产品销售占比 + 服务订单状态分布 */
export function getStatisticsCharts() {
  return request({ url: '/admin/statistics/charts', method: 'post' })
}
